import React, { useContext } from "react";
import { ThemeContext } from "../../../../../Theme";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";
// import { google_api } from "../../../../../config";
import icon from "../../../../../assets/images/Logo-farmageo-borde.png";

export function Mapa(props) {
  const { data, cab } = props;
  const { api_key_maps } = useContext(ThemeContext)

  // Obtener latitud y longitud desde data o desde las propiedades del objeto cab
  const lat = data[cab.id_a + "_mapa_latitud"] ?? cab.mapa_latitud;
  const lng = data[cab.id_a + "_mapa_longitud"] ?? cab.mapa_longitud;
  const zoom = cab.mapa_zoom ? Number(cab.mapa_zoom) : lat && lng ? 15 : 3;

  const center = {
    lat: lat ?? -38.416097,
    lng: lng ?? -63.616672,
  };

  // Estado para InfoWindow (opcional, si necesitas mostrar contenido adicional)
  const [showInfoWindow, setShowInfoWindow] = React.useState(false);

  // Función para manejar el clic en el marcador
  const handleMarkerClick = () => {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`);
  };

  // Opciones de contenedor del mapa
  const containerStyle = {
    width: "100%",
    height: cab.height || "200px",
  };

  return (
    <div className="map_container" style={containerStyle}>
      <LoadScript googleMapsApiKey={api_key_maps}>
        <GoogleMap mapContainerStyle={containerStyle} zoom={zoom} center={center}>
          <Marker
            position={center}
            icon={{
              url: icon,
              // Usamos window.google para definir el tamaño y el ancla del ícono.
              // Estos valores se aplican una vez que la API de Google Maps se haya cargado.
              anchor: new window.google.maps.Point(25, 25),
              scaledSize: new window.google.maps.Size(55, 55),
            }}
            onClick={handleMarkerClick}
          />
          {showInfoWindow && (
            <InfoWindow
              position={center}
              onCloseClick={() => setShowInfoWindow(false)}
            >
              <div>
                {/* Aquí puedes poner el contenido que desees en el InfoWindow */}
                <span>Información del marcador</span>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
}

export default Mapa;
